var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable complexity */
import { memo, Suspense, useEffect } from 'react';
import { DEFAULT_ERROR_FALLBACK as ErrorFallback, DEFAULT_DELAYED_FALLBACK as DelayLoader, } from './config/constants';
import OnIdle from '../IdleUntilUrgent';
import { DELAYS } from '../../utils/tti';
import { isRemoteLoaded } from './helpers/remote';
//@ts-ignore
import { noop } from '@mindtickle/utils';
import useDynamicScript from './hooks/useDynamicScript';
import useRemoteInitialisation from './hooks/useRemoteInitialisation';
import usePerformanceLoggerForRemote from './hooks/usePerformanceLoggerForRemote';
function LoadRemote(_a) {
    var remote = _a.remote, _b = _a.lazy, lazy = _b === void 0 ? true : _b, _c = _a.loader, loader = _c === void 0 ? _jsx(DelayLoader, {}, void 0) : _c, onRender = _a.children, _d = _a.maxDelay, maxDelay = _d === void 0 ? DELAYS.L : _d, _e = _a.onIdleEnabled, onIdleEnabled = _e === void 0 ? true : _e, _f = _a.onDownloadCompleted, onDownloadCompleted = _f === void 0 ? noop : _f, _g = _a.shouldFailSilently, shouldFailSilently = _g === void 0 ? false : _g, _h = _a.isReactComponent, isReactComponent = _h === void 0 ? true : _h, _j = _a.shouldRenderAsChildren, shouldRenderAsChildren = _j === void 0 ? false : _j, props = __rest(_a, ["remote", "lazy", "loader", "children", "maxDelay", "onIdleEnabled", "onDownloadCompleted", "shouldFailSilently", "isReactComponent", "shouldRenderAsChildren"]);
    var _k = usePerformanceLoggerForRemote(remote), onLoad = _k.onLoad, onModuleEvaluation = _k.onModuleEvaluation;
    var _l = useDynamicScript({
        url: remote === null || remote === void 0 ? void 0 : remote.url,
        alreadyInitialised: isRemoteLoaded(remote.remoteName),
        onLoad: onLoad,
    }), isManifestReady = _l.ready, failed = _l.failed;
    var _m = useRemoteInitialisation(remote, isManifestReady, lazy, maxDelay, shouldFailSilently, onModuleEvaluation), isReadyForRendering = _m.isReadyForRendering, downloadCompleted = _m.downloadCompleted, moduleDetails = _m.moduleDetails;
    useEffect(function () {
        if (downloadCompleted) {
            onDownloadCompleted();
        }
    }, [downloadCompleted]);
    if (!remote) {
        return _jsx("h2", { children: "No remote specified" }, void 0);
    }
    if (failed) {
        return _jsx(_Fragment, { children: !shouldFailSilently && _jsx(ErrorFallback, {}, void 0) }, void 0);
    }
    if (!isManifestReady || !isReadyForRendering) {
        return loader;
    }
    var _o = moduleDetails, Component = _o.Component, module = _o.module;
    var innerComponent = (_jsxs(_Fragment, { children: [isReactComponent && (_jsx(Component, __assign({}, props, { children: shouldRenderAsChildren ? onRender : null }), void 0)), !shouldRenderAsChildren && onRender && onRender(module)] }, void 0));
    var onIdleWrapped = (_jsx(OnIdle, __assign({ placeholder: loader, syncUpdate: true }, { children: innerComponent }), void 0));
    return _jsx(Suspense, __assign({ fallback: loader }, { children: onIdleEnabled ? onIdleWrapped : innerComponent }), void 0);
}
export default memo(LoadRemote);
//# sourceMappingURL=LoadRemote.js.map